<template>
  <div
    class="icon"
    :class="[iconSize, iconActive]"
    @click="toggleActive"
  />
</template>

<script>
export default {
  data() {
    return {
      active: false,
    }
  },
  props: {
    size: {
      type: String,
      default: "24",
    },
    name: {
      type: String,
      default: "menu",
    },
    lightModeColour: {
      type: String,
      default: "black",
    },
    darkModeColour: {
      type: String,
      default: "white",
    },
    activeEffect: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    iconName() {
      return this.$store.state.mode.darkMode
        ? `grunticon__icon-${this.$props.name}-${this.darkModeColour}`
        : `grunticon__icon-${this.$props.name}-${this.lightModeColour}`;
    },
    iconSize() {
      return `icon-${parseInt(this.size, 10)}`;
    },
    iconActive() {
      return this.active && this.activeEffect ? `grunticon__icon-${this.$props.name}-white purple rounded-sm` : this.iconName
    },
  },
  methods: {
    toggleActive() {
      this.active = !this.active;
    },
  }
};
</script>

<style lang="scss" scoped>

svg {
  fill: currentColor;
}

.icon {
  i > {
    fill: currentColor;
  }
}

$sizes: (
  14: 14px,
  16: 16px,
  18: 18px,
  20: 20px,
  24: 24px,
  28: 28px,
  32: 32px,
  40: 40px,
  48: 48px,
  64: 64px,
  128: 128px,
  256: 256px,
);

@mixin icon-sizes {
  @each $name, $px in $sizes {
    &-#{$name} {
      height: $px;
      width: $px;
      background-size: $px;
      background-position: center;
    }
  }
}

.icon {
  @include icon-sizes;
}
</style>